export default __webpack_public_path__ + "static/media/sadprojimg.e68cb613.jpeg";